// extracted by mini-css-extract-plugin
export default {"header":"header_header__MhatS","welcome":"header_welcome__YuRS4","thumbnail":"header_thumbnail__zc5uG","userData":"header_userData__0+a4j","role":"header_role__YSw37"};